export default __webpack_public_path__ + "static/loja-3-5dfd1c5506c2cc74aa9b06fe10beced7.png";